window.hpModelIndex = [
  {
    model: "300DVBNPV7",
    manufacturer: "Majestic",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/300dvbnpv7"
  },
  {
    model: "300DVBNSCSL",
    manufacturer: "Majestic",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/300dvbnscsl"
  },
  {
    model: "300DVBNVSL",
    manufacturer: "Majestic",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/300dvbnvsl"
  },
  {
    model: "300DVBPSCSL",
    manufacturer: "Majestic",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/300dvbpscsl"
  },
  {
    model: "500DVBNVSL",
    manufacturer: "Majestic",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/500dvbnvsl"
  },
  {
    model: "BLDV300NSCSL",
    manufacturer: "Monessen",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/bldv300nscsl"
  },
  {
    model: "HEIR36H",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir36h"
  },
  {
    model: "HEIR36-IFT-LP",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir36-ift-lp"
  },
  {
    model: "HEIR36-IFT-NG",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir36-ift-ng"
  },
  {
    model: "HEIR36T",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir36t"
  },
  {
    model: "HEIR42H",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir42h"
  },
  {
    model: "HEIR42-IFT-LP",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir42-ift-lp"
  },
  {
    model: "HEIR42-IFT-NG",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir42-ift-ng"
  },
  {
    model: "HEIR42T",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir42t"
  },
  {
    model: "HEIR50H",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir50h"
  },
  {
    model: "HEIR50-IFT-LP",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir50-ift-lp"
  },
  {
    model: "HEIR50-IFT-NG",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir50-ift-ng"
  },
  {
    model: "HEIR50T",
    manufacturer: "Heatilator",
    type: "Gas Fireplace",
    url: "/pages/fireplace-model/heir50t"
  },
  {
    model: "MDVI30IN",
    manufacturer: "Majestic",
    type: "Gas Insert",
    url: "/pages/fireplace-model/mdvi30in"
  }
];